import { authUrl, isTokenValid } from "infra/auth/sso-login";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { getLocalStorageItem, clearLocalStorage } from "presentation/utils/localStorage";
import { getSessionStorageItem, setSessionStorageItem, clearSessionStorage } from "presentation/utils/sessionStorage";
import { useIsMobile } from "presentation/mobile/hooks/useIsMobile";
import logo from "../../../assets/logo.svg";
import "./index.css";

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const unauthorized = searchParams.get("unauthorized") === "true";
  const isMobile = useIsMobile();

  const sessionKey = "auth-session-storage";
  const sessionData = getSessionStorageItem(sessionKey);
  const lastRoute = getLocalStorageItem("lastRoute") ?? "";

  // Removido let accessToken

  if (sessionData) {
    try {
      const parsed = JSON.parse(sessionData);
      const expiresAt = parsed?.state?.expiresAt ?? 0;
      if (
        isTokenValid(expiresAt) &&
        (unauthorized === undefined || unauthorized === false)
      ) {
        let redirectPath = lastRoute;
        if (!redirectPath || redirectPath === "/" || redirectPath === "/login") {
          redirectPath = isMobile ? "/mobile" : "/dashboards";
        } else if (isMobile && !redirectPath.startsWith("/mobile")) {
          redirectPath = `/mobile${redirectPath.startsWith("/") ? "" : "/"}${redirectPath}`;
        }

        const basePath = process.env.REACT_APP_BASENAME || "";
        let finalUrl = window.location.origin + basePath;

        if (!finalUrl.endsWith("/") && !redirectPath.startsWith("/")) {
          finalUrl += "/" + redirectPath;
        } else if (finalUrl.endsWith("/") && redirectPath.startsWith("/")) {
          finalUrl += redirectPath.substring(1);
        } else {
          finalUrl += redirectPath;
        }

        window.location.href = finalUrl;
      } else {
        clearLocalStorage();
        clearSessionStorage();
      }
    } catch (err) {
      console.error("Erro ao parsear auth-session-storage:", err);
    }
  }

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    process.env.REACT_APP_HOSTING_ENV === "local";

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const login = async () => {
    try {
      const authRedirect = await authUrl();
      //console.log("authRedirect", authRedirect);
      setSessionStorageItem("codeVerifier", authRedirect.codeVerifier);
      window.location.href = authRedirect.url;
    } catch (error) {
      console.error("Erro ao obter URL de autenticação:", error);
    }
  };

  const handleDevLogin = async () => {
    if (!email || !email.trim()) {
      alert("Por favor, introduza um e-mail válido.");
      return;
    }
    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3001";
      const cleanEmail = email.trim();
      const derivedName = cleanEmail.split("@")[0].replace(/[._-]/g, " ");

      const response = await fetch(`${baseUrl}/auth/dev-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_DEV_API_KEY || "ns2V3hKoBP3e1ACDH6JzeHiT",
        },
        body: JSON.stringify({
          name: derivedName,
          email: cleanEmail,
        }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || `Erro no login dev: ${response.status}`);
      }

      const tokenData = await response.json();
      if (tokenData.accessToken) {
        setSessionStorageItem(
          sessionKey,
          JSON.stringify({
            state: {
              accessToken: tokenData.accessToken,
              refreshToken: tokenData.refreshToken,
              userName: tokenData.userName,
              email: tokenData.email,
              expiresAt: tokenData.expiresAt,
              expiresIn: tokenData.expiresIn,
            },
            version: 0,
          })
        );
        const targetPath = isMobile ? "/mobile" : "/dashboards";
        window.location.href = targetPath;
      }
    } catch (err: any) {
      console.error("Falha no login de bypass:", err);
      alert("Erro no bypass de login: " + (err.message || err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />
        <InputText
          placeholder="E-mail"
          className="w-full"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={!isLocalhost}
        />
        <Password
          placeholder="Senha"
          className="password-full w-full"
          toggleMask
          feedback={false}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={!isLocalhost}
        />
        <div className="login-options">
          <div className="flex align-items-center">
            <Checkbox inputId="rememberMe" name="rememberMe" checked={true} />
            <label htmlFor="rememberMe" className="ml-2">
              Lembrar
            </label>
          </div>
          <Button
            className="forget-password"
            label="Esqueceu sua senha?"
            link
            onClick={() => window.open("#")}
          />
        </div>
        <div className="login-button">
          <Button
            label={loading ? "Aceder..." : "Aceder"}
            className="spacing-button"
            disabled={!isLocalhost || loading}
            onClick={handleDevLogin}
          />
          <Button
            label="Aceder com Microsoft"
            className="spacing-button p-button-outlined"
            onClick={login}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
